import { ErrorOutline } from '@material-ui/icons';
import { Box, Grid, Typography } from '@mui/material'
import React from 'react'
import { translateFunc } from '../../../Helpers/translateFunc';

export const MainData = ({ t, error, selectedAsset, data }) => {
    //Funcion para ordenar de a 4 los datos
    const chunkArray = (array, size) =>
        array.reduce((acc, _, i) => 
          (i % size === 0 ? [...acc, array.slice(i, i + size)] : acc), []);

    return (
        <Box sx={{ my: 2, px: 2, pt:1, boxShadow: "1", backgroundColor: '#f5f5f5' }}>
            <Box
                sx={{
                    my: 2,
                    backgroundColor: '',
                    borderRadius: 3,
                    overflow: 'hidden',
                }}
            >
                <Typography 
                    variant="h6" 
                    textAlign="center" 
                    sx={{
                        pb: 2
                    }}
                >
                    {t(`controlPanel.mainTitle.${selectedAsset?.id}`)}
                </Typography>
                {error && 
                    <Box sx={{ pb: 2 }}>
                        <Typography className='fw-bold text-danger' textAlign="center">
                            <ErrorOutline sx={{ color: "#e91e63" }} fontSize='medium'/> {translateFunc(t, `controlPanel.error.${error}`, error)}
                        </Typography>
                    </Box>
                }
                {chunkArray(data || [], 4).map((group, groupIndex) => (
                    <Grid container spacing={2} key={groupIndex} sx={{pb:2}}>
                        {group.map((mainData, index) => (
                            <Grid
                                item
                                key={index}
                                xs={12}
                                sm={12 / group.length}
                            >
                                <Box
                                    sx={{
                                        border: '1px solid',
                                        borderColor: 'grey.300',
                                        borderRadius: 2,
                                        overflow: 'hidden',
                                        boxShadow: "1"
                                    }}
                                >
                                    <Box
                                        sx={{
                                            backgroundColor: 'primary.main',
                                            py: 0.5
                                        }}
                                    >
                                        <Typography variant="body2" textAlign="center" color={'primary.contrastText'} fontWeight={'bold'}>
                                            {t(`controlPanel.titles.${mainData.title}`)}
                                        </Typography>
                                    </Box>
                                    <Typography variant="h5" fontWeight="bold" textAlign="center" sx={{py:1}}>
                                        {mainData.value}
                                    </Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                ))}
            </Box>
        </Box>
    )
}
